import IconLetters from '../../../SoftwareMap/nodes/icons/IconLetters.jsx'
import Color from '../../../SoftwareMap/nodes/Color.mjs';
import { type CrudDataType, CrudEnumType } from './types';


const crudIconMap = {
  [CrudEnumType.create]: <IconLetters fill={Color.GREEN} letters="C" textColor="#fff" />,
  [CrudEnumType.delete]: <IconLetters fill={Color.RED} letters="D" textColor="#fff" />,
  [CrudEnumType.read]: <IconLetters fill={Color.DARK_CYAN} letters="R" textColor="#fff" />,
  [CrudEnumType.update]: <IconLetters fill={Color.DARK_CYAN} letters="U" textColor="#fff" />
}

export default crudIconMap;

export {
  Color
};